import type { FooterConfig } from "../../config";
import { FooterCollapsableDesktop } from "./footer-collapsable-desktop";
import { FooterCollapsableMobile } from "./footer-collapsable-mobile";
import { FooterFixed } from "./footer-fixed";
import styles from "./footer.module.css";
import { FooterProvider } from "./providers/footer.provider";

export type FooterProps = {
  baseURL: string;
  links?: FooterConfig;
  /** Quando true, URLs do domínio webmotors abrem na mesma aba. Redes sociais (Instagram, TikTok, etc.) sempre abrem em nova janela. */
  shouldOpenInSameWindow?: boolean;
};

export function Footer({
  baseURL,
  links,
  shouldOpenInSameWindow = false,
}: Readonly<FooterProps>) {
  return (
    <FooterProvider
      baseURL={baseURL}
      customLinks={links}
      shouldOpenInSameWindow={shouldOpenInSameWindow}
    >
      <footer className={styles.Footer}>
        <div className={styles.Content}>
          <FooterCollapsableMobile />
          <FooterCollapsableDesktop />
          <FooterFixed />
        </div>
        <div className={styles.Disclaimer}>
          © 1995-{new Date().getFullYear()} Webmotors S.A. CNPJ
          03.347.828/0001-09 Todos os direitos reservados.
        </div>
      </footer>
    </FooterProvider>
  );
}
